import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CeloFileUploader } from "@modules/shared/file-upload";

@Component({
  selector: "app-drop-box",
  templateUrl: "./drop-box.component.html",
  styleUrls: ["./drop-box.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DropBoxComponent implements OnInit {
  @Output() browse = new EventEmitter();
  dropZoneActive: string;
  uploader: CeloFileUploader;
  hideSubtitle: boolean;
  singleFileOnly = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public uploaderInput: CeloFileUploader,
    private ref: MatDialogRef<DropBoxComponent>
  ) {}

  ngOnInit() {
    this.uploader = this.uploaderInput;
    this.hideSubtitle = this.uploaderInput["hideSubtitle"];
    this.singleFileOnly = this.uploaderInput["singleFileOnly"];
  }

  browseNow() {
    this.browse.emit();
    this.closeNow();
  }

  closeNow() {
    this.ref.close(this.uploader);
  }

  dropZoneState(state: boolean) {
    this.dropZoneActive = state ? "valid" : "";
  }

  handleDrop(files: FileList) {
    this.ref.close(this.uploader);
  }
}
